module.exports = __webpack_public_path__ + "static/media/feat-bonjour-hero.786d8f43.jpg";